var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 240,
    viewBox: "0 0 412 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "var(--card-thumbnail-bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2539_1081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.833 111.667H264.333V78.3334C264.333 69.1667 256.833 61.6667 247.667 61.6667H214.333V49.1667C214.333 37.6667 205 28.3334 193.5 28.3334C182 28.3334 172.667 37.6667 172.667 49.1667V61.6667H139.333C130.167 61.6667 122.75 69.1667 122.75 78.3334V110H135.167C147.583 110 157.667 120.083 157.667 132.5C157.667 144.917 147.583 155 135.167 155H122.667V186.667C122.667 195.833 130.167 203.333 139.333 203.333H171V190.833C171 178.417 181.083 168.333 193.5 168.333C205.917 168.333 216 178.417 216 190.833V203.333H247.667C256.833 203.333 264.333 195.833 264.333 186.667V153.333H276.833C288.333 153.333 297.667 144 297.667 132.5C297.667 121 288.333 111.667 276.833 111.667Z",
    fill: "var(--card-thumbnail-fg)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2539_1081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(106 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataset);
export default __webpack_public_path__ + "static/media/dataset.56f3c620935b0584df263ac60f11db38.svg";
export { ForwardRef as ReactComponent };